export class ClientItem {
  id: number = 0;
  name: string = '';
  logoname: string = '';
  messageToAllClients: string = '';
}

export class CustomerItem {
  id: number = 0;
  isWebAdmin: boolean = false;
  company: string = '';
  lastName: string = '';
  firstName: string = '';
  street1: string = '';
  street2: string = '';
  postalCode: string = '';
  city: string = '';
  showArticlePrice: boolean = false;
  showArticleSecondLanguage: boolean = false;
  message: string = '';
  barcodePluStart: number = 0;
  barcodePluLength: number = 0;
  topArticlesOrders: number = 0;
  topArticlesAmount: number = 0;
  switchToArticleList: boolean = false;
  client: ClientItem = new ClientItem();
  isOrderlist: boolean = false;
}

export class OrderItem {
  id: number = 0;
  orderDate: Date = new Date();
  deliveryDate: Date = new Date();
  comment: string = '';
  state: number = 0;
  customer: CustomerItem = new CustomerItem();
  orderDetails: OrderDetailItem[] = [];
}

export const OrderState = ['Offen', 'Abgeschlossen', 'Abgeholt', 'In Bearbeitung', 'Fertiggestellt'] as const;

export class OrderDetailItem {
  id: number = 0;
  orderId: number = 0;
  articleId: number = 0;
  articleNo: string = '';
  articleName: string = '';
  webArticleInfo: string = '';
  amount: number = 0;
  portioningAmount: number = 0;
  unit: string = '';
  isOrderlist: boolean = false;
  comment: string = '';
  article: ArticleItem = new ArticleItem();
  timestamp: Date = new Date();

  constructor(
    fields?: {
      id?: number,
      orderId?: number,
      articleId?: number,
      articleNo?: string,
      articleName?: string,
      webArticleInfo?: string,
      amount?: number,
      portioningAmount?: number,
      unit?: string,
      isOrderlist?: boolean,
      comment?: string,
    }) {
    if (fields) Object.assign(this, fields);
  }
}

export class ArticleItem {
  id: number = 0;
  no: string = '';
  name: string = '';
  nameSecondLanguage: string = '';
  price: number = 0;
  inactive: boolean = false;
  unit: string = '';
  webArticleInfo: string = '';
  articlePortioning: boolean = false;
  orderCount: number = 0;
  orderAmount: number = 0;
  articlePhotos: ArticlePhotoItem[] = [];
}

export class ArticlePhotoItem {
  id: number = 0;
  articleId: number = 0;
  filename: string = '';
  filedate: Date = new Date();
  filesize: number = 0;
}

export class ArticlelistDetailItem {
  id: number = 0;
  amount: number = 0;
  portioningAmount: number = 0;
  comment: string = '';
  defaultAmount: number = 0;
  sortOrder: number = 0;
  textLine: string = '';
  article: ArticleItem | null = new ArticleItem();
  timestamp: Date = new Date();
  orderDetailItemId: number = 0;
  compoundKey: string = '';
}

export class DocumentItem {
  id: number = 0;
  filename: string = '';
  filedate: Date = new Date();
  filesize: number = 0;
  content: Uint8Array = new Uint8Array();
}

export class PromotionItem {
  id: number = 0;
  title: string = '';
  validFrom: Date = new Date();
  validUntil: Date = new Date();
  customer: CustomerItem = new CustomerItem();
  promotionArticles: PromotionArticleItem[] = [];
}

export class PromotionArticleItem {
  id: number = 0;
  price: number = 0;
  article: ArticleItem = new ArticleItem();
}
